import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getCommissions } from '../../commission-plans/actions/commission-actions';

import '../styles/commission-scheme-ib.css';

class CommissionSchemeIb extends Component {
  state = {
    showAllSymbols: false,
  };

  componentDidMount() {
    const { getCommissions } = this.props;

    getCommissions();
  }

  handleShowAllPromotions = () => {
    this.setState({ showAllSymbols: true });
  };

  render() {
    const { t } = this.context;
    const { commissions, httpInProgress } = this.props;
    const { showAllSymbols } = this.state;
    const promotions = showAllSymbols ? commissions : commissions.slice(0, 5);

    if (!commissions.length && !httpInProgress) {
      return <h4>{t('COMMISSION_SCHEME.NO_PLAN_ASSIGNED')}</h4>;
    }

    return (
      <div className="commission-scheme-ib">
        <h3> {t('COMMISSION_SCHEME.INTRODUCING_BROKER_TITLE')} </h3>
        <div className="ib-commission-table-container table-responsive commission-ib-table">
          <table className="ib-commission-table-container__table">
            <thead className="ib-commission-table-container__table__head">
              <tr className="ib-commission-table-container__table__head__row">
                <th>{t('COMMISSION_SCHEME.TABLE_SYMBOL')}</th>
                <th>{t('COMMISSION_SCHEME.TABLE_SYMBOL_TYPE')}</th>
                <th>{t('COMMISSION_SCHEME.TABLE_COMISSION_PER_LOT')}</th>
              </tr>
            </thead>
            <tbody className="ib-commission-table-container__table__body">
              {promotions.map((commision, i) => (
                <tr className="ib-commission-table-container__table__body__row" key={i}>
                  <td>{commision.symbol_name}</td>
                  <td>{commision.symbol_type}</td>
                  <td>{commision.reward}</td>
                </tr>
              ))}
              {!showAllSymbols && (
                <tr className="ib-commission-table-container__table__body__row__all">
                  <td colSpan="3">
                    <a onClick={this.handleShowAllPromotions}>{t('COMMISSION_SCHEME.TABLE_SHOW_ALL')}</a>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <p>{t('COMMISSION_SCHEME.CALCULATED_COMMISSIONS')}</p>
        <p>{t('COMMISSION_SCHEME.PAYOUTS')}</p>
      </div>
    );
  }
}

CommissionSchemeIb.contextTypes = {
  t: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  httpInProgress: state.httpInProgressReducer.httpInProgress,
  commissions: state.commissionReducer.commissions,
});

const mapDispatchToProps = dispatch => ({
  getCommissions: () => {
    dispatch(getCommissions());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CommissionSchemeIb);



// WEBPACK FOOTER //
// ./src/app/main/commission-scheme/components/commission-scheme-ib.js